module.exports = __webpack_public_path__ + "static/media/amazing_girl_x6aihr.ffc9f5a2.png";